import {Component, OnInit, HostBinding} from '@angular/core';
import {Title, Meta} from '@angular/platform-browser';
import {AnimationsMetaData} from '../../_animations/animations.metadata';
import {Subscription} from 'rxjs/Subscription';
import {AnimationService} from '../../_animations/animations.service';
import {RouteDirections, IRouteDirection} from '../../_animations/route-directions.constant';

@Component({
  selector: 'app-deepcrawl',
  providers: [AnimationService, RouteDirections],
  templateUrl: './deepcrawl.component.html',
  styleUrls: ['./deepcrawl.component.css'],
  animations: [AnimationsMetaData]
})
export class DeepcrawlComponent implements OnInit {
  @HostBinding('@routing') routing;
  @HostBinding('style.display') display = 'block';
  animationServiceEventsSubscription: Subscription;
  public routeDirections: IRouteDirection[];

  constructor(private Title: Title,
              private Meta: Meta,
              private animationService: AnimationService,
              routeDirections: RouteDirections) {
    this.routeDirections = routeDirections.deepcrawl;
  }

  ngOnInit() {
    this.Title.setTitle('DeepCrawl - Work | Alec Bertram');
    this.Meta.addTag({name: 'description', content: 'DeepCrawl is a B2B MarTech SaaS which helps businesses to grow and protect revenue by providing valuable digital marketing insights to enterprise ecommerce, marketplace, and publishing clients.'});
    this.routing = this.animationService.animationDirection();
    this.animationServiceEventsSubscription = this.animationService.emitCurrentDirection
      .subscribe((direction: any) => this.routing = direction);
  }

  go(direction: string, url: string) {
    return this.animationService.routingService(direction, url);
  }
  pan($event, url: string) {
    return this.animationService.mobileRoutingSerivce($event, url);
  }
}



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/work/deepcrawl/deepcrawl.component.ts